let apidaePrestasListeItem = {

    props: {
        prestaItems: Array,
        lang: String,
        showDate: Number,
        showTarif: Number
    },
    template: `
        <div class="grid__item" v-for="(prestaItem, index) in prestaItems">
            <a v-bind:href="prestaItem.url" class="single-item">
                <div class="grid__img">
                    <img v-if="!!prestaItem.prestaVO.images.length > 0" v-bind:src="prestaItem.prestaVO.images[0].miniUrl" alt="" width="640" height="480" />
                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
                        <rect x="00" y="00" width="640" height="480" fill="#F2F2F2" />
                    </svg>
                </div>
                <div class="grid__inner">
                    <div class="date" v-if="showDate">
                        <div class="date-double" v-if="prestaItem.prestaVO.dateDebut != prestaItem.prestaVO.dateFin">
                            <div class="dateDebut">
                                <span class="day">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) }}</span>
                                <span class="month">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) }}</span>
                            </div>
                            <i class="fa-thin fa-chevron-right"></i>
                            <div class="dateFin">
                                <span class="day">{{ prestaItem.prestaVO.dateFin | formatTimestamp('Do', lang) }}</span>
                                <span class="month">{{ prestaItem.prestaVO.dateFin | formatTimestamp('MMM', lang) }}</span>
                            </div>
                        </div>
                        <div class="date-simple" v-else>
                            <div class="dateDebut">
                                <span class="day">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) }}</span>
                                <span class="month">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) }}</span>
                            </div>
                        </div>
                    </div>
                    <h2 class="text-center" v-html="prestaItem.title"></h2>
                    <div class="grid__sub">
                        <div class="gotto" v-if="prestaItem.prestaVO.sousCategories.length > 0 || prestaItem.prestaVO.categorie">
                            <template v-if="prestaItem.prestaVO.sousCategories.length > 0" v-for="(sousCategorie, index) in prestaItem.prestaVO.sousCategories.slice(0,1)">
                                    {{ sousCategorie.label }}<br>
                            </template>
                            <template v-else-if="prestaItem.prestaVO.categorie">
                                {{ prestaItem.prestaVO.categorie }}
                            </template>
                            <template v-if="prestaItem.prestaVO.pictoClassement">
                                &nbsp;<img :src="prestaItem.prestaVO.pictoClassement.url" :alt="prestaItem.prestaVO.pictoClassement.legende" :title="prestaItem.prestaVO.pictoClassement.legende" :width="prestaItem.prestaVO.pictoClassement.width" :height="prestaItem.prestaVO.pictoClassement.height">
                            </template>
                        </div>
                        <div class="grid__datetime">
                            <span class="grid__commune">
                                <i class="fad fa-location-dot"></i>&nbsp;
                                <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.cpltDistribution">{{ prestaItem.prestaVO.adresse.cpltDistribution }}&nbsp;</span>
                                <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.numNomVoie">{{ prestaItem.prestaVO.adresse.numNomVoie }}&nbsp;</span>
                                <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.lieuDit">{{ prestaItem.prestaVO.adresse.lieuDit }}</span>
                                <template v-if="prestaItem.prestaVO.adresse.cpltDistribution || prestaItem.prestaVO.adresse.numNomVoie || prestaItem.prestaVO.adresse.lieuDit">-&nbsp;</template>
                                <template v-if="prestaItem.prestaVO.commune">{{ prestaItem.prestaVO.commune }}</template>
                            </span>
                        </div>
                    </div>
                </div>
            </a>
        </div>`
};

{
    /* <div class="ouverture" v-if="prestaItem.prestaVO.dateDebut != prestaItem.prestaVO.dateFin">
        Du {{ prestaItem.prestaVO.dateDebut | formatTimestamp('dddd Do MMMM', lang) }} au {{ prestaItem.prestaVO.dateFin | formatTimestamp('dddd Do MMMM Y', lang) }}
    </div>
    <div class="ouverture" v-else>
        {{ prestaItem.prestaVO.dateDebut | formatTimestamp('dddd Do MMMM Y', lang) }}
    </div> */
}

//   <p v-html="$options.filters.stripTags(prestaItem.description)"></p>
{
    /* <div class="date" v-if="showDate">
        <div class="date-double" v-if="prestaItem.prestaVO.dateDebut != prestaItem.prestaVO.dateFin">
            <div class="dateDebut">
                <span class="day">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) }}</span>
                <span class="month">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) }}</span>
                <span class="year">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('YY', lang) }}</span>
            </div>
            <div class="dateFin">
                <span class="day">{{ prestaItem.prestaVO.dateFin | formatTimestamp('Do', lang) }}</span>
                <span class="month">{{ prestaItem.prestaVO.dateFin | formatTimestamp('MMM', lang) }}</span>
                <span class="year">{{ prestaItem.prestaVO.dateFin | formatTimestamp('YY', lang) }}</span>
            </div>
        </div>
        <div class="date-simple" v-else>
            <div class="dateDebut">
                <span class="day">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) }}</span>
                <span class="month">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) }}</span>
                <span class="year">{{ prestaItem.prestaVO.dateDebut | formatTimestamp('YY', lang) }}</span>
            </div>
        </div>
    </div> */
}

{
    /* <div class="grid__sub">
        <div class="grid__datetime">
            <span v-if="!!prestaItem.dureeSejour">{{ prestaItem.dureeSejour }}</span>
            <span class="grid__commune" v-if="!!prestaItem.commune"><i class="fad fa-location-dot"></i> {{ prestaItem.commune }}</span>
        </div>
        <div class="grid__price" v-if="showTarif">
            <span v-if="prestaItem.tarifMin">à partir de</span> <span v-if="prestaItem.tarifMin">{{ prestaItem.tarifMin }} &euro;</span><span v-else-if="prestaItem.tarifMax">{{ prestaItem.tarifMax }} &euro;</span>
        </div>
    </div>  */
}